import { Box, CircularProgress, Typography } from '@mui/material';

import { Button, ButtonVariants, ModalContentContainer } from '@/components';
import { Episode, Plan } from '@/types';

interface RedeemModalContentProps {
  episode?: Episode;
  plan?: Plan;
  claimEpisodeResult: {
    isSuccess: boolean;
    isLoading: boolean;
  };
  onRedeemEpisode: () => void;
  closeModal: () => void;
}

export const RedeemModalContent = ({
  episode,
  plan,
  claimEpisodeResult,
  onRedeemEpisode,
  closeModal,
}: RedeemModalContentProps) => {
  if (!episode) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress sx={{ my: 10 }} />
      </Box>
    );
  }

  const creditsRemaining = Math.round((plan?.usageRemaining ?? 0) * 10) / 10;
  const showUsageRemaining = plan?.showUsageRemaining;
  const creditsRequired = episode.CPEDetails?.credits ?? 0;

  return (
    <ModalContentContainer onModalClose={closeModal}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}>
        {!claimEpisodeResult.isSuccess ? (
          <>
            {showUsageRemaining ? (
              <>
                <Typography variant="h3">
                  You have {creditsRemaining} credits available
                </Typography>
                {creditsRemaining <= creditsRequired ? (
                  <Typography variant="body2">
                    Would you like to use your remaining credits towards this
                    episode?
                  </Typography>
                ) : (
                  <Typography variant="body2">
                    Would you like to use <b>{creditsRequired}</b> credits
                    towards this episode?
                  </Typography>
                )}
              </>
            ) : (
              <Typography variant="h3">
                Would you like to redeem this episode?
              </Typography>
            )}
            <Typography
              variant="subtitle1"
              color="secondary.main"
              sx={{ mb: 1 }}>
              <i>{episode.name}</i>
            </Typography>
            <Button
              variant={ButtonVariants.PRIMARY}
              skinny={false}
              label="Redeem"
              onClick={onRedeemEpisode}
              isLoading={claimEpisodeResult.isLoading}
            />
          </>
        ) : (
          <>
            <Typography variant="h3">Episode Redeemed!</Typography>
            {showUsageRemaining && (
              <Typography variant="body2">
                You have {creditsRemaining} credits remaining
              </Typography>
            )}
            <Button
              variant={ButtonVariants.PRIMARY}
              skinny={false}
              label="Close"
              onClick={closeModal}
            />
          </>
        )}
      </Box>
    </ModalContentContainer>
  );
};
